import { SITE_FONT_STACK } from "../../utils/styles/fontStack";

export default {
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected ? "#eee" : "#ffffff",
      color: "#333",
      whiteSpace: "nowrap",
      fontSize: "0.87rem",
      fontWeight: state.isSelected ? 600 : 400,
      lineHeight: "1.31rem",
      height: 29,
      display: "flex",
      alignItems: "center",
      cursor: "pointer",
    }),
    control: (provided) => ({
      ...provided,
      width: "fit-content",
      height: 38,
      background: "transparent",
      borderRadius: 10,
      border: "1px solid #ffffff33",
      boxShadow: "none",
      cursor: "pointer",
      "&:hover": {
        outline: "none",
        boxShadow: "none",
      },
      "&:active": {
        outline: "none",
        boxShadow: "none",
      },
      "&:focus": {
        outline: "none",
        boxShadow: "none",
      },
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (provided) => ({
      ...provided,
      padding: 0,
      paddingInlineStart: 20,
      // Was a bare "Poppins", which has no Hebrew glyphs. See SITE_FONT_STACK.
      fontFamily: SITE_FONT_STACK,
      fontSize: ".87rem",
      lineHeight: "1.31rem",
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#fff",
    }),
    menu: (provided) => ({
      ...provided,
      boxShadow: "0px 4px 9px rgba(116, 116, 116, 0.25)",
      borderRadius: 5,
      zIndex: 1000,
    }),
    menuPortal: (provided) => ({
      ...provided,
      zIndex: 1000,
    }),
    menuList: (provided) => ({
      ...provided,
      zIndex: 1000,
    }),
  }; 